import { Injectable } from '@angular/core';
import {catchError, Observable, retry} from "rxjs";
import {NotesModel} from "../models-otc/notes-model";
import { HttpClient } from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {HelperService} from "../../helper.service";
import {BaseService} from "../../services/base.service";
import {tap} from "rxjs/operators";
@Injectable({
    providedIn: 'root'
})
export class NotesService extends BaseService{

    constructor(
        private httpClient: HttpClient,
        public snackBar: MatSnackBar,
        public helper: HelperService,
    ) {
        super();
    }

    /// GET ///
    getNoteList(orderId:number): Observable<NotesModel[]> {
        return this.httpClient.get<NotesModel[]>(this.OTC_BASE_URL + `orders/${orderId}/notes`)
            .pipe(
                retry(0),
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving Notes','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }


    /// POST ///

    postNewNote(note: string, orderId: number): Observable<NotesModel> {
        const noteBody = {
            note: note,
            orderId: orderId,
        }
        return this.httpClient.post<NotesModel>(this.OTC_BASE_URL + 'orders/notes',noteBody)
            .pipe(
                retry(0),
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Creating New Note','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }


    /// PUT ///
    updateOrderNote(id: number, note: string, orderId:number): Observable<NotesModel> {
        return this.httpClient.put<NotesModel>(this.OTC_BASE_URL +`orders/notes` , {id:id,note:note,orderId:orderId})
            .pipe(
                retry(0),
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Updating Note','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                }),
                tap(() => {
                    this.snackBar.open('Update Successful', 'close', {
                        duration: 5000,
                    });
                })
            );
    }

/// DELETE ///
    deleteNoteListItem(id: number): Observable<string> {
        return this.httpClient.delete(this.OTC_BASE_URL + `orders/notes/${id}`,{ responseType: 'text' })
            .pipe(
                retry(0),
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Removing Note','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                }),
                tap(() => {
                    this.snackBar.open('Note Removed Successfully', 'close', {
                        duration: 5000,
                    });
                })
            );
    }
}
